import { defineComponent } from "vue";
import { VueBrowseClasses } from "../../../classes";
import ScrollContainer from "../../../components/default/scrollContainer";

export default /*#__PURE__*/ defineComponent(
    {
        name: "defaultTemplate",
        setup(_, { slots })
        {
            return () => (
                <div class={VueBrowseClasses.Body}>
                    {slots.header?.()}
                    <ScrollContainer class={VueBrowseClasses.InnerBody}>
                        <table class={{
                            [VueBrowseClasses.Table]: true
                        }}>
                            {slots.body?.()}
                        </table>
                    </ScrollContainer>
                    {slots.footer?.()}
                </div>);
        }
    }
);